var _react_refresh_temp_1, _react_refresh_temp_2;
var _react_refresh_temp_3;
_react_refresh_temp_3 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { createSelector } from '@reduxjs/toolkit';
import { useTranslation } from 'react-i18next';
import { useAppSelector, useAppDispatch, store, } from '../../../store';
import { updateIsActiveParticipantsPanel } from '../../../store/slices/bottomIconsActivitySlice';
import { participantsSelector } from '../../../store/slices/participantSlice';
const isActiveParticipantsPanelSelector = createSelector(_react_refresh_temp_1 = (state) => state.bottomIconsActivity, (bottomIconsActivity) => bottomIconsActivity.isActiveParticipantsPanel);
$RefreshReg$(_react_refresh_temp_1, "isActiveParticipantsPanelSelector$createSelector");
const ParticipantIcon = () => {
    _react_refresh_temp_3();
    const dispatch = useAppDispatch();
    const showTooltip = store.getState().session.userDeviceType === 'desktop';
    const { t } = useTranslation();
    const isActiveParticipantsPanel = useAppSelector(isActiveParticipantsPanelSelector);
    const participantsTotal = useAppSelector(participantsSelector.selectTotal);
    const [iconCSS, setIconCSS] = useState('primaryColor');
    useEffect(() => {
        if (isActiveParticipantsPanel) {
            setIconCSS('secondaryColor');
        }
        else {
            setIconCSS('primaryColor dark:text-darkText');
        }
    }, [isActiveParticipantsPanel]);
    const toggleParticipantsPanel = () => {
        dispatch(updateIsActiveParticipantsPanel(!isActiveParticipantsPanel));
    };
    return (_jsxs("div", { className: `participants footer-icon h-[35px] lg:h-[40px] w-[35px] lg:w-[40px] ltr:mr-3 lg:ltr:mr-6 rtl:ml-3 lg:rtl:ml-6 relative rounded-full bg-[#F2F2F2] dark:bg-darkSecondary2 hover:bg-[#ECF4FF] flex items-center justify-center cursor-pointer ${showTooltip ? 'has-tooltip' : ''}`, onClick: () => toggleParticipantsPanel(), children: [_jsx("span", { className: "tooltip", children: isActiveParticipantsPanel
                    ? t('footer.icons.hide-users-list')
                    : t('footer.icons.show-users-list') }), _jsx("i", { className: `pnm-participant ${iconCSS} text-[14px] lg:text-[16px]` }), !isActiveParticipantsPanel ? (_jsx("div", { className: "unseen-message-count bg-secondaryColor w-5 h-5 rounded-full text-xs text-white absolute -top-2 -right-1 flex justify-center items-center", children: participantsTotal })) : null] }));
};
_react_refresh_temp_2 = ParticipantIcon;
$RefreshReg$(_react_refresh_temp_2, "ParticipantIcon");
_react_refresh_temp_3(ParticipantIcon, "oEhIorCr7hcKs/gnGiUTYNYxdEU=", false, () => [useAppDispatch, useTranslation, useAppSelector, useAppSelector]);
export default ParticipantIcon;
